"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _InlineMarkdown = _interopRequireDefault(require("../../../Utils/InlineMarkdown"));

var _useLocalizer = _interopRequireDefault(require("../../../hooks/useLocalizer"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MARKDOWN_REFERENCES = ['RETRY'];

var SendFailedRetry = function SendFailedRetry(_ref) {
  var onRetryClick = _ref.onRetryClick;
  var handleReference = (0, _react.useCallback)(function (_ref2) {
    var data = _ref2.data;
    return data === 'RETRY' && onRetryClick();
  }, [onRetryClick]);
  var localize = (0, _useLocalizer.default)();
  var sendFailedText = localize('ACTIVITY_STATUS_SEND_FAILED_RETRY');
  return _react.default.createElement(_InlineMarkdown.default, {
    onReference: handleReference,
    references: MARKDOWN_REFERENCES
  }, sendFailedText);
};

SendFailedRetry.propTypes = {
  onRetryClick: _propTypes.default.func.isRequired
};
var _default = SendFailedRetry;
exports.default = _default;